<template>
  <custom-button
    @click.stop="$emit('onClick')"
    button-type="blue"
  >
    <span class="d-flex align-items-center column-gap-2">
      <IconAILinear />
      <span>{{ label }}</span>
    </span>
  </custom-button>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: "Initiate AI Training",
  },
});

defineEmits(["onClick"]);
</script>

<style scoped lang="scss">
:deep(.icon-ai path) {
  fill: $neutral-0;
}
</style>
